import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { FETCH_TENANT_SSO_SETTINGS } from '@modules/workspaceSettings/hooks/useFetchTenantSSOSettings';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Typography,
} from '@mui/material';
import { useRemoveTenantSsoMutation } from 'generated/graphql';
import { FormEvent } from 'react';
import { useGetUser } from 'v2/core/services/user';

export const RemoveSSOModalContent = () => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();
  const { closeModal } = useMuiModalContext();
  const { showSuccessNotification, showErrorNotification } =
    useNotificationContext();

  const [removeTenantSSO, { loading }] = useRemoveTenantSsoMutation({
    variables: {
      request: {
        tenantID,
      },
    },
    refetchQueries: [FETCH_TENANT_SSO_SETTINGS],
  });

  const onClose = () => closeModal();

  const onRemove = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await removeTenantSSO();
      closeModal();
      showSuccessNotification({
        contentComponent: 'SSO Removed',
        props: { isClosable: true },
      });
    } catch {
      showErrorNotification({
        contentComponent: 'Failed to remove SSO',
        props: { isClosable: true },
      });
    }
  };

  const isRemoveDisabled = false;

  return (
    <Box component="form" onSubmit={onRemove}>
      <ModalHeader title="Remove SSO" />
      <Divider />
      <DialogContent>
        <Typography variant="body2">
          Are you sure you want to remove SSO configuration?
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ m: 1, mr: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          type="button"
          disabled={loading}
        >
          Cancel
        </Button>
        <LoadingButton
          variant="outlined"
          color="error"
          disabled={isRemoveDisabled}
          loading={loading}
          type="submit"
        >
          Remove
        </LoadingButton>
      </DialogActions>
    </Box>
  );
};
